function requireAll( r ) {
	r.keys().forEach( r );
}

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/ ) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/ ) );
requireAll( require.context( './png/', true, /\.png$/ ) );
//requireAll( require.context( './gif/', true, /\.gif$/) );

import $ from 'jquery';
import Headroom from 'headroom.js';

import tabsList from '../../../../../vendor/tabsspaces/tabslist/src/assets/tabsList.js';

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import L from './js/leaflet';

import Plyr from 'plyr';

import lottie from 'lottie-web';

import Mustache from 'mustache';

import confetti from 'canvas-confetti';

window.jQuery = $;
window.$      = $;

window.setCookie = function( name, value, days ) {
	let expires = '';

	if ( days ) {
		var d = new Date();
		d.setTime( d.getTime() + 24 * 60 * 60 * 1000 * days );
		expires = d.toGMTString();
	}

	document.cookie = name + '=' + value + ';path=/;expires=' + expires + ';secure';
};

window.getCookie = function( name ) {
	var v = document.cookie.match( '(^|;) ?' + name + '=([^;]*)(;|$)' );
	return v ? v[ 2 ] : null;
};

window.deleteCookie = function( name ) {
	setCookie( name, '', -1 );
};

$( function() {
	var PROJECT = {
		prefs: {
			isReduced:
				window.matchMedia( `(prefers-reduced-motion: reduce)` ) === true ||
				window.matchMedia( `(prefers-reduced-motion: reduce)` ).matches === true,
		},

		common: {
			getViewport: function() {
				var viewPortWidth;
				var viewPortHeight;

				if ( typeof window.innerWidth !== 'undefined' ) {
					viewPortWidth  = window.innerWidth;
					viewPortHeight = window.innerHeight;
				} else if (
					typeof document.documentElement !== 'undefined' &&
					typeof document.documentElement.clientWidth !== 'undefined' &&
					document.documentElement.clientWidth !== 0
				) {
					viewPortWidth  = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;
				} else {
					viewPortWidth  = document.getElementsByTagName( 'body' )[ 0 ].clientWidth;
					viewPortHeight = document.getElementsByTagName( 'body' )[ 0 ].clientHeight;
				}

				return { width: viewPortWidth, height: viewPortHeight };
			},

			init: function() {
				PROJECT.nav.init();

				PROJECT.toggle.init();

				PROJECT.header.init();

				PROJECT.gform.init();

				PROJECT.list.init();

				PROJECT.video.init();

				PROJECT.simpleAnimations.init();

				PROJECT.cardLink.init();

				PROJECT.langSwitch.init();

				PROJECT.accordion.init();

				PROJECT.carouselsSplide.init();

				PROJECT.carouselsSwiper.init();

				PROJECT.locationDialog.init();

				PROJECT.table.init();

				PROJECT.maps.init();

				PROJECT.lottie.init();

				PROJECT.cards.init();

				PROJECT.styleCarousel.init();

				PROJECT.studioCarousel.init();

				PROJECT.stepsCarousel.init();

				PROJECT.lightboxGallery.init();

				PROJECT.intakePopup.init();

				PROJECT.navigationBar.init();

				PROJECT.navDrag.init();

				PROJECT.cardStudio.init();

				PROJECT.equalHeightCards.init();

				PROJECT.fireworks.init();
			},
		},

		toggle: {
			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {
				$( document ).on( 'click', PROJECT.toggle.clickElm, PROJECT.toggle.switch );
			},

			switch: function( e ) {
				let $elm = $( this );

				let $label = $elm.find( PROJECT.toggle.labelElm );

				let toggleText = $elm.data( PROJECT.toggle.dataAttr );

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text( newText );

				$elm.attr( 'title', newText );
			},
		},

		nav: {
			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */

			mainElm: '.jsHeader',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-header--nav-open',
			openSubMenuClass: 'state-c-header--v-nav-sub-menu-open',
			subMenuElm: '.jsSubMenuToggle',
			mobileNavBreakpoint: 1023,

			init: function() {
				PROJECT.nav.sticky();

				$( document ).on( 'click', PROJECT.nav.clickElm, PROJECT.nav.toggle );

				$( document ).on( 'click', PROJECT.nav.subMenuElm, PROJECT.nav.toggleSubMenu );

				$( document ).on( 'keyup', PROJECT.nav.esc );
			},

			sticky: function() {
				var body = $( 'body' ).get( 0 );

				var headerSticky = new Headroom( body, {
					offset: 250,
					tolerance: {
						up: 5,
						down: 0,
					},
					classes: {
						initial: 'state-c-header',
						pinned: 'state-c-header--pinned',
						unpinned: 'state-c-header--unpinned',
						top: 'state-c-header--top',
						notTop: 'state-c-header--not-top',
						bottom: 'state-c-header--bottom',
						notBottom: 'state-c-header--not-bottom',
					},
				} );

				headerSticky.init();
			},

			toggle: function( e ) {
				e.preventDefault();

				if ( $( 'html' ).hasClass( PROJECT.nav.openClass ) ) {
					PROJECT.nav.close();
				} else {
					PROJECT.nav.open();
				}
			},

			esc: function( e ) {
				if ( e.keyCode === 27 ) {
					if ( $( 'html' ).hasClass( PROJECT.nav.openClass ) ) {
						PROJECT.nav.close();
					}
				}
			},

			open: function() {
				$( 'html' ).addClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {
					$( this ).removeAttr( 'tabindex', -1 );
				} );
			},

			close: function() {
				$( 'html' ).removeClass( PROJECT.nav.openClass );

				PROJECT.nav.closeSubMenu();

				$( PROJECT.nav.mainElm + ' a' ).each( function() {
					$( this ).attr( 'tabindex', -1 );
				} );
			},

			toggleSubMenu: function( e ) {
				e.preventDefault();

				if ( !!$( '.v-nav__item--sub-menu-open' ).length ) {
					PROJECT.nav.closeSubMenu();
				} else {
					PROJECT.nav.openSubMenu( $( this ) );
				}
			},

			openSubMenu: function( $this ) {
				$( 'html' ).addClass( PROJECT.nav.openSubMenuClass );

				$this.closest( '.v-nav__item' ).addClass( 'v-nav__item--sub-menu-open' );
			},

			closeSubMenu: function() {
				$( 'html' ).removeClass( PROJECT.nav.openSubMenuClass );

				$( '.v-nav__item--sub-menu-open' ).removeClass( 'v-nav__item--sub-menu-open' );
			},
		},

		cardLink: {
			init: function() {
				PROJECT.cardLink.alignImages();
			},

			alignImages: function() {
				const cards = document.querySelectorAll( '.jsViewCardLink' );

				function checkAlignment() {
					let tallHeight = 80;
					if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
						tallHeight = 100;
					}

					cards.forEach( ( card ) => {
						const wrapper = card.querySelector( '.v-card-link__content' );
						if ( wrapper && wrapper.offsetHeight > tallHeight ) {
							card.classList.add( 'v-card-link--tall' );
						} else {
							card.classList.remove( 'v-card-link--tall' );
						}
					} );
				}

				if ( cards.length > 0 ) {
					checkAlignment();
					window.addEventListener( 'resize', checkAlignment );
				}
			},
		},

		cardStudio: {
			init: function() {
				PROJECT.cardStudio.alignImages();
			},

			alignImages: function() {
				const cards = document.querySelectorAll( '.jsViewCardStudio' );

				function checkAlignment() {
					const tallHeight = 100;

					cards.forEach( ( card ) => {
						console.log( card );
						const wrapper = card.querySelector( '.v-card-studio__wrapper-header' );
						if ( wrapper && wrapper.offsetHeight > tallHeight ) {
							wrapper.classList.add( 'v-card-studio__wrapper-header--tall' );
						} else {
							wrapper.classList.remove( 'v-card-studio__wrapper-header--tall' );
						}
					} );
				}

				if ( cards.length > 0 ) {
					checkAlignment();
					window.addEventListener( 'resize', checkAlignment );
				}
			},
		},

		equalHeightCards: {
			init: function() {

				PROJECT.equalHeightCards.makeEqual();
				window.addEventListener( 'resize', PROJECT.equalHeightCards.makeEqual );
			},
			makeEqual: function() {
				var carousels = document.querySelectorAll( '.jsEqualHeightCards' );

				if ( typeof carousels === 'object' && carousels.length > 0 ) {

					carousels.forEach( ( carousel, index ) => {
						const firstCards       = [];
						let maxFirstCardHeight = 0;

						const slides   = carousel.querySelectorAll( '.v-blocks-grid__carousel-slide' );
						const allCards = carousel.querySelectorAll( '.v-card-icon-block' );

						allCards.forEach( ( card ) => (card.style.height = '') );

						slides.forEach( ( slide ) => {
							const cards = slide.querySelectorAll( '.v-card-icon-block' );

							if ( cards[ 0 ] ) {
								firstCards.push( cards[ 0 ] );

								if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
									const firstCardHeight = cards[ 0 ].offsetHeight;
									if ( firstCardHeight > maxFirstCardHeight ) {
										maxFirstCardHeight = firstCardHeight;
									}
								} else {
									maxFirstCardHeight = 'auto';
								}
							}
						} );

						if (maxFirstCardHeight !== 'auto') {
							maxFirstCardHeight = maxFirstCardHeight + 'px';
						}

						firstCards.forEach( ( card ) => (card.style.height = maxFirstCardHeight) );
					} );
				}
			}

		},

		langSwitch: {
			mainElm: '.jsLangSwitch',
			clickElm: '.jsLangSwitchToggle',
			openClass: 'state-v-lang-switch--lang-switch-open',

			init: function() {
				$( document ).on( 'click', PROJECT.langSwitch.clickElm, PROJECT.langSwitch.toggle );
				$( document ).on( 'keyup', PROJECT.langSwitch.esc );

				$( document ).off( 'click.langSwitchOuterClose' );
				$( document ).on( 'click.langSwitchOuterClose', 'body', PROJECT.langSwitch.outerClose );
			},

			toggle: function( e ) {
				e.preventDefault();

				if ( $( 'html' ).hasClass( PROJECT.langSwitch.openClass ) ) {
					PROJECT.langSwitch.close();
				} else {
					PROJECT.langSwitch.open();
				}
			},

			open: function() {
				$( 'html' ).addClass( PROJECT.langSwitch.openClass );

				$( PROJECT.langSwitch.mainElm + ' > a' ).each( function() {
					$( this ).removeAttr( 'tabindex', -1 );
				} );
			},

			close: function() {
				$( 'html' ).removeClass( PROJECT.langSwitch.openClass );

				$( PROJECT.langSwitch.mainElm + ' > a' ).each( function() {
					$( this ).attr( 'tabindex', -1 );
				} );
			},

			esc: function( e ) {
				if ( e.keyCode === 27 ) {
					PROJECT.langSwitch.close();
				}
			},

			outerClose: function( e ) {
				var mainLangElm = $( PROJECT.langSwitch.mainElm );

				if ( !mainLangElm.is( e.target ) && mainLangElm.has( e.target ).length === 0 ) {
					PROJECT.langSwitch.close();
				}
			},
		},

		header: {
			init: function() {
				PROJECT.header.getHeight( '.jsSiteHeader', '--header-site-height' );

				window.onresize = function() {
					PROJECT.header.getHeight( '.jsSiteHeader', '--header-site-height' );
				};
			},

			getHeight: function( targetClass, cssVariable ) {
				var $this = $( targetClass );

				if ( $this.length > 0 ) {
					$( 'html' ).css( cssVariable, $this.height() );
				}
			},
		},

		gform: {
			init: function() {
				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );

				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );
				$( document ).on( 'click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'submit', '.gform_wrapper form', PROJECT.gform.showLoader );

				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );

				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );

				$( document ).on( 'focus', 'input, textarea, select', function() {
					$( this )
					.parents( '.gfield' )
					.addClass( 'state--has-focus' );
				} );

				$( document ).on( 'blur', 'input, textarea, select', function( e ) {
					if ( !$( this ).val() ) {
						$( this )
						.parents( '.gfield' )
						.removeClass( 'state--has-focus' );
					}
				} );

				PROJECT.gform.fixHasFocus();
			},

			fixHasFocus: function() {
				$( 'input, textarea, select' ).each( function() {
					if ( $( this ).val() ) {
						$( this )
						.parents( '.gfield' )
						.addClass( 'state--has-focus' );
					}
				} );
			},

			showLoader: function() {
				var $gformContainer = $( this ).closest( '.gformContainer' );
				var $gformLoader    = $gformContainer.find( '.gformLoader' );

				$gformLoader.fadeIn( 300 ).css( 'display', 'flex' );
			},

			hideLoader: function() {
				$( '.gformLoader' ).fadeOut( 300 );
			},

			showConfirmation: function() {
				$( '.gformConfirmation' )
				.fadeIn( 300 )
				.css( 'display', 'flex' );
			},

			hideConfirmation: function() {
				$( '.gformConfirmation' ).fadeOut( 300 );
			},
		},

		list: {
			sectionClass: 's-list',
			filterContainerClass: 'jsFilterContainer',
			stateClass: 'state-list--filter-open',

			init: function() {
				window.tabsList.init( {
					scrollToTop: true,
					callbacks: {
						afterAjaxCallback: function( data ) {},
					},
				} );

				$( document ).on( 'click', '.jsListFiltersOpen', PROJECT.list.openFilters );
				$( document ).on( 'click', '.jsListFiltersClose', PROJECT.list.closeFilters );
			},

			openFilters: function( e ) {
				e.preventDefault();

				$( this )
				.closest( '.' + PROJECT.list.sectionClass )
				.addClass( PROJECT.list.sectionClass + '--filters-open' );
			},

			closeFilters: function( e ) {
				e.preventDefault();

				$( this )
				.closest( '.' + PROJECT.list.sectionClass )
				.removeClass( PROJECT.list.sectionClass + '--filters-open' );
			},
		},

		video: {
			playersArray: [],

			init: function() {
				PROJECT.video.render();
			},

			render: function() {
				var players = document.querySelectorAll( '.jsVideo' );

				if ( typeof players === 'object' && players.length > 0 ) {
					players.forEach( ( playerTarget, index ) => {
						var $target    = playerTarget.querySelector( '.jsVideoPlayer' );
						var playButton = playerTarget.querySelector( '.jsVideoPlay' );

						const provider    = $target.hasAttribute( 'data-plyr-provider' ) ? false : true;
						const controls    = $target.hasAttribute( 'controls' ) ? true : false;
						const autoplay    = $target.hasAttribute( 'autoplay' ) ? true : false;
						const muted       = $target.hasAttribute( 'muted' ) ? true : false;
						const loop        = $target.hasAttribute( 'loop' ) ? true : false;
						const clickToPlay = $target.hasAttribute( 'autoplay' ) ? false : true;
						const volume      = $target.hasAttribute( 'muted' ) ? 0 : 0.5;

						const player = new Plyr( $target, {
							clickToPlay: clickToPlay,
							muted: muted,
							volume: volume,
							autoplay: autoplay,
							loop: { active: loop },
							controls: controls ? [ 'play', 'progress', 'volume', 'mute', 'fullscreen' ] : [], //['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
							hideControls: false,
							storage: {
								enabled: false,
							},
							fullscreen: {
								enabled: true,
								fallback: true,
								iosNative: provider,
							},
							playsinline: true,
							vimeo: {
								playsinline: true,
								loop: true,
							},
							youtube: {
								playsinline: true,
								loop: true,
								noCookie: true,
								rel: false,
							},
						} );

						player.on( 'ready', ( event ) => {
							if ( autoplay === true ) {
								player.play();
							}
						} );

						player.on( 'play', ( event ) => {
							playerTarget.classList.add( 'jsVideoPlaying' );
						} );

						player.on( 'pause', ( event ) => {
							playerTarget.classList.remove( 'jsVideoPlaying' );
						} );

						if ( playButton ) {
							playButton.addEventListener( 'click', () => {
								if ( player.paused ) {
									player.play();
								} else {
									player.pause();
								}
							} );
						}

						PROJECT.video.playersArray.push( player );
					} );
				}
			},
		},

		simpleAnimations: {
			init: function() {
				PROJECT.simpleAnimations.sectionFadeInUp();
				PROJECT.simpleAnimations.rotateHighlightedText();
			},

			sectionFadeInUp: function() {
				var animateElms = document.querySelectorAll( '.jsSectionFadeUp' );

				PROJECT.simpleAnimations.animate( animateElms );
			},

			rotateHighlightedText: function() {
				var animateElms = document.querySelectorAll( '[class*=a-text-highlighted-]' );

				PROJECT.simpleAnimations.animate( animateElms, 0.25 );
			},

			animate: function( elems, threshold ) {
				if ( typeof elems === 'object' && elems.length > 0 ) {
					if ( !threshold ) {
						threshold = 0.1;
					}

					// Define observer instance
					var observer = new IntersectionObserver( onIntersection, {
						root: null, // default is the viewport
						rootMargin: '0px 0px 0% 0px',
						threshold: threshold, // percentage of target's visible area. Triggers "onIntersection"
					} );

					// callback is called on intersection change
					function onIntersection( entries, opts ) {
						for ( let j = 0; j < entries.length; j++ ) {
							let entry = entries[ j ];

							// One time animations
							if ( entry.isIntersecting ) {
								let thisElm = entry.target;

								thisElm.classList.add( 'animDone' );

								// Stop observing:
								observer.unobserve( thisElm );
							}
						}
					}

					for ( let i = 0; i < elems.length; i++ ) {
						let thisElm = elems[ i ];

						// Use the observer to observe an element
						observer.observe( thisElm );
					}
				}
			},
		},

		carouselsSplide: {
			init: function() {
				PROJECT.carouselsSplide.footerCarousel();

				PROJECT.carouselsSplide.testimonialGridCarousel();

				PROJECT.carouselsSplide.blocksGridCarousel();
			},

			blocksGridCarousel: function() {
				var carousels = document.querySelectorAll( '.jsBlocksGridCarousel' );

				if ( typeof carousels === 'object' && carousels.length > 0 ) {

					carousels.forEach( ( carousel, index ) => {

						if ( carousel.classList.contains( 'v-blocks-grid--slider-active-md' ) ) {

							const carouselContainer = carousel.querySelector( '.jsCarousel' );

							const options = {
								autoWidth: false,

								perMove: 1,
								perPage: 4,

								freeMode: true,

								direction: 'ltr',

								gap: '48px',

								arrows: false,
								pagination: true,

								autoScroll: {
									speed: 1,
									pauseOnHover: true,
									pauseOnFocus: true,
								},

								breakpoints: {
									1023: {
										destroy: true,
									},
								},
							};

							let splide = new Splide( carouselContainer, options ).mount( {} );

						}

					} );

				}
			},

			footerCarousel: function() {
				var carousels = document.querySelectorAll( '.jsFooterCarousel' );

				if ( typeof carousels === 'object' && carousels.length > 0 ) {
					carousels.forEach( ( carousel, index ) => {
						const carouselContainer = carousel.querySelector( '.jsCarousel' );

						const clonesNeeded = PROJECT.carouselsSplide.getCloneCount( carouselContainer );

						let splide = new Splide( carouselContainer, {
							type: 'loop',
							autoWidth: true,

							perMove: 1,

							direction: 'ltr',

							clones: clonesNeeded,

							arrows: false, // Hide navigation arrows
							pagination: false, // Hide pagination dots

							autoScroll: {
								speed: 0.25,
								pauseOnHover: false,
								pauseOnFocus: false,
							},
						} ).mount( { AutoScroll } );
					} );
				}
			},

			testimonialGridCarousel: function() {
				var carousels = document.querySelectorAll( '.jsTestimonialGridCarousel' );

				if ( typeof carousels === 'object' && carousels.length > 0 ) {
					carousels.forEach( ( carousel, index ) => {
						const carouselContainer = carousel.querySelector( '.jsCarousel' );

						const splide = new Splide( carouselContainer, {
							type: 'loop',

							perMove: 1,

							perPage: 1,

							padding: '50px',

							gap: '16px',

							focus: 'center',

							arrows: false,

							pagination: true,

							mediaQuery: 'min',
							breakpoints: {
								768: {
									padding: '25%',
								},

								1024: {
									destroy: true,
								},
							},
						} ).mount();
					} );
				}
			},

			getCloneCount: function( carouselContainer ) {
				const carouselContainerWidth = carouselContainer.offsetWidth;

				const windowWidth = window.innerWidth;

				const horizontalFit = Math.floor( windowWidth / carouselContainerWidth );

				const slides = carouselContainer.querySelectorAll( '.splide__slide' );

				return horizontalFit * slides.length;
			},

			arrows: function( carousel, splide, hide = false ) {
				const controlsDiv = carousel.querySelector( '.jsCarouselControls' );

				if ( controlsDiv !== null ) {
					const prev = carousel.querySelector( '.jsCarouselPrev' );
					const next = carousel.querySelector( '.jsCarouselNext' );

					prev.addEventListener( 'click', () => splide.go( '<' ) );
					next.addEventListener( 'click', () => splide.go( '>' ) );

					const updateFn = () => PROJECT.carouselsSplide.updateArrows( splide, controlsDiv, prev, next, hide );
					splide.on( 'mounted move resize', updateFn );

					updateFn();
				}
			},

			updateArrows: function( splide, controlsDiv, prevBtn, nextBtn, hide ) {
				// Loop sliders never disable
				if ( splide.options.type === 'loop' ) {
					prevBtn.disabled = nextBtn.disabled = false;
					return;
				}

				const slides = splide.Components.Elements.list.children;
				const track  = splide.Components.Elements.track;
				const index  = splide.index;
				const total  = splide.length;

				let visibleSlides = 1;

				if ( splide.options.autoWidth ) {
					const trackWidth = track.offsetWidth;

					let widthSum = 0;
					for ( let i = index; i < slides.length; i++ ) {
						widthSum += slides[ i ].offsetWidth;
						if ( widthSum >= trackWidth ) break;
						visibleSlides++;
					}
				} else {
					visibleSlides = splide.options.perPage || 1;
				}

				if ( hide === true ) {
					if ( total <= visibleSlides ) {
						controlsDiv.style.display = 'none';
					} else {
						controlsDiv.style.display = 'block';
					}
				}

				// Disable prev if first slide
				prevBtn.disabled = index === 0;

				// Disable next if last visible slide reaches end
				nextBtn.disabled = index + visibleSlides >= total;
			},

			drag: function( splide ) {
				let prevDragState = null;

				const updateFn = () => {
					const { list, track } = splide.Components.Elements;
					const isOverflowing   = list.scrollWidth > track.clientWidth;

					if ( isOverflowing !== prevDragState ) {
						prevDragState  = isOverflowing;
						splide.options = { ...splide.options, drag: isOverflowing };
					}
				};

				// Run after layout settles
				splide.on( 'mounted resize updated', () => {
					setTimeout( updateFn, 0 );
				} );

				updateFn();
			},
		},

		carouselsSwiper: {
			init: function() {
				PROJECT.carouselsSwiper.blockCarousel();
				PROJECT.carouselsSwiper.postCarousel();
				PROJECT.carouselsSwiper.teamCarousel();
			},

			blockCarousel: function() {
				let carouselsSections = document.querySelectorAll( '.jsBlocksCarousel' );

				if ( carouselsSections.length > 0 ) {
					carouselsSections.forEach( function( carouselsSection ) {
						let carousels  = carouselsSection.querySelectorAll( '.jsCarousel' );
						let pagination = carouselsSection.querySelector( '.jsCarouselPagination' );

						if ( carousels.length > 0 ) {
							const breakpoint    = 768;
							let swiperInstances = [];

							function initSwiper() {
								if ( window.innerWidth <= breakpoint ) {
									carousels.forEach( function( carouselEl ) {
										// Check if swiper already exists for this element
										const existingIndex = swiperInstances.findIndex( ( sw ) => sw.el === carouselEl );
										if ( existingIndex === -1 ) {
											const swiper = new Swiper( carouselEl, {
												modules: [ Pagination ],

												slidesPerView: 'auto',

												spaceBetween: 16,

												pagination: {
													el: pagination,
													type: 'bullets',
													clickable: true,
												},
											} );
											swiperInstances.push( swiper );
										}
									} );
								}
							}

							function destroySwiper() {
								if ( window.innerWidth > breakpoint && swiperInstances.length > 0 ) {
									swiperInstances.forEach( function( swiperInstance ) {
										swiperInstance.destroy( true, true );
									} );
									swiperInstances = [];
								}
							}

							function handleResize() {
								if ( window.innerWidth > breakpoint ) {
									destroySwiper();
								} else {
									initSwiper();
								}
							}

							initSwiper();
							window.addEventListener( 'resize', handleResize );
						}
					} );
				}
			},

			postCarousel: function() {
				let carouselsSections = document.querySelectorAll( '.jsPostCarousel' );

				if ( carouselsSections.length > 0 ) {
					carouselsSections.forEach( function( carouselsSection ) {
						let carousels = carouselsSection.querySelectorAll( '.jsCarousel' );

						let buttonPrev = carouselsSection.querySelector( '.jsCarouselPrev' );
						let buttonNext = carouselsSection.querySelector( '.jsCarouselNext' );
						let pagination = carouselsSection.querySelector( '.jsCarouselPagination' );

						if ( carousels.length > 0 ) {
							carousels.forEach( function( carouselEl ) {
								const swiper = new Swiper( carouselEl, {
									modules: [ Pagination, Navigation ],

									slidesPerView: 'auto',

									navigation: {
										nextEl: buttonNext,
										prevEl: buttonPrev,

										navigationDisabledClass: 's-icons__control--disabled',
										lockClass: 's-icons__control--locked',
									},

									pagination: {
										el: pagination,
										type: 'bullets',
										clickable: true,
									},
								} );
							} );
						}
					} );
				}
			},

			teamCarousel: function() {
				let carouselsSections = document.querySelectorAll( '.jsTeamCarousel' );

				if ( carouselsSections.length > 0 ) {
					carouselsSections.forEach( function( carouselsSection ) {
						let carousels = carouselsSection.querySelectorAll( '.jsCarousel' );

						let buttonPrev = carouselsSection.querySelector( '.jsCarouselPrev' );
						let buttonNext = carouselsSection.querySelector( '.jsCarouselNext' );
						let pagination = carouselsSection.querySelector( '.jsCarouselPagination' );

						if ( carousels.length > 0 ) {
							carousels.forEach( function( carouselEl ) {
								const swiper = new Swiper( carouselEl, {
									modules: [ Pagination, Navigation ],

									slidesPerView: 'auto',

									navigation: {
										nextEl: buttonNext,
										prevEl: buttonPrev,

										navigationDisabledClass: 's-icons__control--disabled',
										lockClass: 's-icons__control--locked',
									},

									loop: true,
									loopAdditionalSlides: 2,

									pagination: {
										el: pagination,
										type: 'bullets',
										clickable: true,
									},
								} );
							} );
						}
					} );
				}
			},
		},

		styleCarousel: {
			sliders: [],

			init: function() {
				PROJECT.styleCarousel.carousel();

				document.addEventListener( 'click', function( event ) {
					const filterEl = event.target.closest( '.jsFilterStyleTypes .jsFilter' );

					if ( filterEl ) {
						PROJECT.styleCarousel.filter( filterEl );
					}
				} );
			},

			carousel: function() {
				let carouselsSections = document.querySelectorAll( '.jsStyleCarousel' );

				if ( carouselsSections.length > 0 ) {
					carouselsSections.forEach( function( carouselsSection ) {
						let carousels  = carouselsSection.querySelectorAll( '.jsCarousel' );
						let pagination = carouselsSection.querySelector( '.jsCarouselPagination' );

						let buttonPrev = carouselsSection.querySelector( '.jsCarouselPrev' );
						let buttonNext = carouselsSection.querySelector( '.jsCarouselNext' );

						if ( carousels.length > 0 ) {
							carousels.forEach( function( carouselEl ) {
								const swiper = new Swiper( carouselEl, {
									modules: [ Pagination, Navigation ],

									slidesPerView: 'auto',

									spaceBetween: 20,

									navigation: {
										nextEl: buttonNext,
										prevEl: buttonPrev,

										navigationDisabledClass: 's-icons__control--disabled',
										lockClass: 's-icons__control--locked',
									},

									pagination: {
										el: pagination,
										type: 'bullets',
										clickable: true,
									},
								} );

								PROJECT.styleCarousel.sliders.push( swiper );
							} );
						}
					} );
				}
			},

			filter: function( target ) {
				let styleTypes      = target.getAttribute( 'filter-style-type' );
				let parentContainer = target.closest( '.jsStyleCarousel' );
				let parentFilters   = target.closest( '.jsFilterStyleTypes' );

				if ( undefined !== parentContainer && undefined !== parentFilters ) {
					let filters       = parentFilters.querySelectorAll( '.jsFilter' );
					let carouselItems = parentContainer.querySelectorAll( '.jsStyleCarouselSlide' );
					let carousel      = parentContainer.querySelector( '.jsCarousel' );

					if ( filters.length > 0 ) {
						filters.forEach( function( filter ) {
							filter.classList.remove( 'active' );
						} );

						const matchedSwiper = PROJECT.styleCarousel.sliders.find( ( swiper ) => swiper.el === carousel );

						if ( matchedSwiper ) {
							matchedSwiper.update();
						}
					}

					if ( carouselItems.length > 0 ) {
						carouselItems.forEach( function( carouselItem ) {
							let slide               = carouselItem.closest( '.swiper-slide' );
							let itemStyleTypes      = carouselItem.getAttribute( 'data-filter-style-type' );
							let itemStyleTypesArray = itemStyleTypes.split( '||' );

							slide.style.display =
								!styleTypes || itemStyleTypesArray.includes( styleTypes ) ? 'block' : 'none';
						} );

						const matchedSwiper = PROJECT.styleCarousel.sliders.find( ( swiper ) => swiper.el === carousel );

						if ( matchedSwiper ) {
							matchedSwiper.update();
						}
					}

					target.classList.toggle( 'active' );
				}
			},
		},

		studioCarousel: {
			sliders: [],

			init: function() {
				PROJECT.studioCarousel.carousel();

				document.addEventListener( 'click', function( event ) {
					const filterEl = event.target.closest( '.jsFilterStudioLocations .jsFilter' );

					if ( filterEl ) {
						PROJECT.studioCarousel.filter( filterEl );
					}
				} );
			},

			carousel: function() {
				let carouselsSections = document.querySelectorAll( '.jsStudioCarousel' );

				if ( carouselsSections.length > 0 ) {
					carouselsSections.forEach( function( carouselsSection ) {
						let carousels = carouselsSection.querySelectorAll( '.jsCarousel' );

						let buttonPrev = carouselsSection.querySelector( '.jsCarouselPrev' );
						let buttonNext = carouselsSection.querySelector( '.jsCarouselNext' );

						if ( carousels.length > 0 ) {
							carousels.forEach( function( carouselEl ) {
								const swiper = new Swiper( carouselEl, {
									modules: [ Pagination, Navigation ],

									slidesPerView: 'auto',

									navigation: {
										nextEl: buttonNext,
										prevEl: buttonPrev,

										navigationDisabledClass: 's-icons__control--disabled',
										lockClass: 's-icons__control--locked',
									},
								} );

								PROJECT.studioCarousel.sliders.push( swiper );
							} );
						}
					} );
				}
			},

			filter: function( target ) {
				let styleTypes      = target.getAttribute( 'filter-studio-location-type' );
				let parentContainer = target.closest( '.jsStudioCarousel' );
				let parentFilters   = target.closest( '.jsFilterStudioLocations' );

				if ( undefined !== parentContainer && undefined !== parentFilters ) {
					let filters       = parentFilters.querySelectorAll( '.jsFilter' );
					let carouselItems = parentContainer.querySelectorAll( '.jsStudioCarouselSlide' );
					let carousel      = parentContainer.querySelector( '.jsCarousel' );

					if ( filters.length > 0 ) {
						filters.forEach( function( filter ) {
							filter.classList.remove( 'active' );
						} );

						const matchedSwiper = PROJECT.studioCarousel.sliders.find( ( swiper ) => swiper.el === carousel );

						if ( matchedSwiper ) {
							matchedSwiper.update();
						}
					}

					if ( carouselItems.length > 0 ) {
						carouselItems.forEach( function( carouselItem ) {
							let slide               = carouselItem.closest( '.swiper-slide' );
							let itemStyleTypes      = carouselItem.getAttribute( 'data-filter-location' );
							let itemStyleTypesArray = itemStyleTypes.split( '||' );

							slide.style.display =
								!styleTypes || itemStyleTypesArray.includes( styleTypes ) ? 'block' : 'none';
						} );

						const matchedSwiper = PROJECT.studioCarousel.sliders.find( ( swiper ) => swiper.el === carousel );

						if ( matchedSwiper ) {
							matchedSwiper.update();
						}
					}

					target.classList.toggle( 'active' );
				}
			},
		},

		accordion: {
			init: function() {
				$( document ).off( 'click', '.jsAccordionTrigger' );
				$( document ).on(
					'click',
					'.jsAccordionTrigger',
					{
						class: 'jsAccordion--open',
						classElement: '.jsAccordion',
						toggleElement: '.jsAccordionTarget',
					},
					PROJECT.accordion.toggle,
				);

				$( document ).off( 'click', '.v-nav--footer-nav .v-nav__item--has-children > a' );
				$( document ).on(
					'click',
					'.v-nav--footer-nav .v-nav__item--has-children > a',
					{
						class: 'v-nav__item--open',
						classElement: '.v-nav__item',
						toggleElement: '.sub-menu',
					},
					PROJECT.accordion.toggle,
				);
			},

			toggle: function( e ) {
				e.preventDefault();

				var parent = $( this ).closest( e.data.classElement );

				if ( !$( parent ).hasClass( e.data.class ) ) {
					$( parent ).addClass( e.data.class );

					if ( e.data.toggleElement !== '' ) {
						$( parent )
						.find( e.data.toggleElement )
						.stop()
						.slideDown( 250 )
						.css( {
							display: 'flex',
						} );
					}
				} else {
					$( parent ).removeClass( e.data.class );

					if ( e.data.toggleElement !== '' ) {
						$( parent )
						.find( e.data.toggleElement )
						.stop()
						.slideUp( 250 )
						.css( {
							display: 'flex',
						} );
					}
				}
			},
		},

		locationDialog: {
			dialogId: 'location_dialog',
			dialog: '',
			mainElm: '.jsLocationDialog',
			clickElm: '.jsLocationDialogToggle',
			openClass: 'state-c-location-dialog--location-dialog-open',
			setLocationElm: '.jsSetLocation',

			init: function() {

				PROJECT.locationDialog.dialog = document.getElementById( PROJECT.locationDialog.dialogId );

				$( document ).on( 'click', PROJECT.locationDialog.clickElm, PROJECT.locationDialog.toggle );
				$( document ).on( 'click', PROJECT.locationDialog.setLocationElm, PROJECT.locationDialog.setLocation );
				$( document ).on( 'keyup', PROJECT.locationDialog.esc );
			},

			toggle: function( e ) {
				e.preventDefault();
				e.stopPropagation();

				if ( $( 'html' ).hasClass( PROJECT.locationDialog.openClass ) ) {
					PROJECT.locationDialog.close( e );
				} else {
					PROJECT.locationDialog.open( e );
				}
			},

			open: function( e ) {
				$( 'html' ).addClass( PROJECT.locationDialog.openClass );

				PROJECT.locationDialog.dialog.showModal();
				PROJECT.locationDialog.dialog.classList.add( 'c-location-dialog--open' );

				$( PROJECT.locationDialog.mainElm + ' button, ' + PROJECT.locationDialog.mainElm + ' a' ).each(
					function() {
						$( this ).removeAttr( 'tabindex', -1 );
					},
				);
			},

			close: function( e ) {
				$( 'html' ).removeClass( PROJECT.locationDialog.openClass );

				PROJECT.locationDialog.dialog.style.pointerEvents = 'none';
				PROJECT.locationDialog.dialog.classList.remove( 'c-location-dialog--open' );
				setTimeout( () => {
					PROJECT.locationDialog.dialog.close();
					PROJECT.locationDialog.dialog.style.removeProperty( 'pointer-events' )
				}, 600 );

				$( PROJECT.locationDialog.mainElm + ' button, ' + PROJECT.locationDialog.mainElm + ' a' ).each(
					function() {
						$( this ).attr( 'tabindex', -1 );
					},
				);
			},

			esc: function( e ) {
				if ( e.keyCode === 27 ) {
					PROJECT.locationDialog.close();
				}
			},

			setLocation: function( e ) {
				var location = $( e.currentTarget ).attr( 'data-location' );

				window.setCookie( 'location_term_id', location, 30 );

				window.location.reload();
			},
		},

		table: {
			init: function() {
				PROJECT.table.tableCarousel();

				PROJECT.table.resizeTable();

				$( window ).on( 'resize orientationchange', PROJECT.table.resizeTable );

				$( document ).on( 'click.cityTab', '.jsTableCityTab', PROJECT.table.cityTab );
			},

			tableCarousel: function() {
				let carouselsSections = document.querySelectorAll( '.jsTableSlider' );

				if ( carouselsSections.length > 0 ) {
					carouselsSections.forEach( function( carouselsSection ) {
						let carousels = carouselsSection.querySelectorAll( '.jsCarousel' );

						if ( carousels.length > 0 ) {
							carousels.forEach( function( carouselEl ) {
								const swiper = new Swiper( carouselEl, {
									modules: [ Pagination, Navigation ],

									slidesPerView: 'auto',
								} );
							} );
						}
					} );
				}
			},

			resizeTable: function() {
				var currentHeights = [];

				$( '.jsTableSlider' ).each( function() {
					var $this = $( this );

					currentHeights = [];

					$( '[data-feature-base]', this ).each( function() {
						$( this ).css( { height: '' } );

						var featureHeight = $( this ).height();
						var featureKey    = $( this ).data( 'feature-base' );

						if ( currentHeights.includes( featureKey ) ) {
							if ( featureHeight > currentHeights[ featureKey ] ) {
								currentHeights[ featureKey ] = featureHeight;
							}
						} else {
							currentHeights[ featureKey ] = featureHeight;
						}
					} );

					$( '[data-feature-resize]', this ).each( function() {
						$( this ).css( { height: '' } );

						var featureHeight = $( this ).height();
						var featureKey    = $( this ).data( 'feature-resize' );

						if ( currentHeights.hasOwnProperty( featureKey ) ) {
							if ( featureHeight > currentHeights[ featureKey ] ) {
								currentHeights[ featureKey ] = featureHeight;
							}
						} else {
							currentHeights[ featureKey ] = featureHeight;
						}
					} );

					if ( currentHeights.length !== 0 ) {
						currentHeights.forEach( ( value, index ) => {
							$( "[data-feature-resize='" + index + "']", $this ).height( value );
							$( "[data-feature-base='" + index + "']", $this ).height( value );
						} );
					}
				} );
			},

			cityTab: function( e ) {
				let target = e.target;

				if ( target !== undefined ) {
					let idTarget        = target.getAttribute( 'data-table-tab' );
					let parentContainer = target.closest( '.jsTableCityParent' );

					if ( parentContainer !== undefined ) {
						let parentTabs   = parentContainer.querySelector( '.jsTableCityTabs' );
						let parentTables = parentContainer.querySelector( '.jsTableCityTables' );

						if ( parentTabs !== undefined && parentTabs !== undefined ) {
							let tabs   = parentTabs.querySelectorAll( '.jsTableCityTab' );
							let tables = parentTables.querySelectorAll( '.jsTableCityTable' );

							tabs.forEach( ( tab ) => {
								let tabId = tab.getAttribute( 'data-table-tab' );

								tab.classList.remove( 'active' );

								if ( tabId === idTarget ) {
									tab.classList.add( 'active' );
								}
							} );

							tables.forEach( ( table ) => {
								let tableId = table.getAttribute( 'data-table-tab' );

								table.classList.remove( 'active' );

								if ( tableId === idTarget ) {
									table.classList.add( 'active' );
								}
							} );

							PROJECT.table.resizeTable();
						}
					}
				}
			},
		},

		maps: {
			init: function() {
				PROJECT.maps.initMaps();
			},

			initMaps: function() {
				let mapsParent = document.querySelectorAll( '.jsStudioMaps' );

				if ( mapsParent.length > 0 ) {
					mapsParent.forEach( function( mapsParent ) {
						let mapContainer = mapsParent.querySelector( '.jsMap' );

						if ( mapContainer !== undefined ) {
							PROJECT.maps.initMap( mapContainer );
						}
					} );
				}
			},

			initMap: function( mapContainer ) {
				let fitBound    = false;
				const allBounds = L.latLngBounds();

				let disableZoom = !!mapContainer.hasAttribute( 'data-disable-zoom' );

				let markers = JSON.parse( mapContainer.getAttribute( 'data-markers' ) );

				const map = L.map( mapContainer, {
					minZoom: 5, // allows zooming out very far
					maxZoom: 18, // normal max zoom in
				} ).setView( [ 52.1326, 5.2913 ], 10 );

				if ( disableZoom === true ) {
					map.dragging.disable();
					map.scrollWheelZoom.disable();
					map.doubleClickZoom.disable();
					map.boxZoom.disable();
					map.keyboard.disable();
					map.touchZoom.disable();
					map.zoomControl.remove();
				}

				L.tileLayer( 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
					maxZoom: 19,
					attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
				} ).addTo( map );

				Object.entries( markers ).forEach( ( [ key, value ] ) => {
					const markersGroup = PROJECT.maps.createFeatureGroup( value.cords, value.function, map );

					allBounds.extend( markersGroup.getBounds() );

					if ( value.cords.length > 0 && fitBound === false ) {
						if ( value.focus === true ) {
							fitBound = true;

							map.fitBounds( markersGroup.getBounds(), {
								padding: [ 50, 50 ],
								maxZoom: 12,
							} );
						}
					}
				} );

				if ( fitBound === false ) {
					map.fitBounds( allBounds, {
						padding: [ 50, 50 ],
					} );
				}
			},

			createFeatureGroup( cords, func, map ) {
				var func = func;

				let customIcon = L.icon( {
					iconUrl: tabs_globals.theme_url + '/dist/png/marker/marker.png',
					iconSize: [ 40, 60 ], // Size of the icon [width, height]
					iconAnchor: [ 20, 40 ], // Point of the icon which will correspond to marker's location
					popupAnchor: [ 0, -40 ], // Point from which the popup should open relative to the iconAnchor
				} );

				const markers = cords.map( ( item ) => {
					const marker = L.marker( [ item.lat, item.lng ], { icon: customIcon } ).addTo( map );

					if ( undefined !== func ) {
						marker.on( 'click', () => {
							if ( null !== func ) {
								PROJECT.maps[ func ]( item.id );
							}
						} );
					}

					return marker;
				} );

				return L.featureGroup( markers ).addTo( map );
			},

			highlightCard: function( id ) {
				console.log( id );
			},
		},

		fireworks: {
			init: function() {
				if ( PROJECT.prefs.isReduced ) {
					return;
				}

				if ( document.body.getAttribute( 'data-homepage-fireworks' ) !== 'true' ) {
					return;
				}

				PROJECT.fireworks.launch();
			},

			launch: function() {
				var duration     = 5 * 1000;
				var animationEnd = Date.now() + duration;
				var defaults     = {
					startVelocity: 30,
					spread: 360,
					ticks: 60,
					zIndex: 10,
				};

				function randomInRange( min, max ) {
					return Math.random() * ( max - min ) + min;
				}

				var interval = setInterval( function() {
					var timeLeft = animationEnd - Date.now();

					if ( timeLeft <= 0 ) {
						return clearInterval( interval );
					}

					var particleCount = 50 * ( timeLeft / duration );

					confetti( {
						...defaults,
						particleCount,
						origin: { x: randomInRange( 0.1, 0.3 ), y: Math.random() - 0.2 },
					} );
					confetti( {
						...defaults,
						particleCount,
						origin: { x: randomInRange( 0.7, 0.9 ), y: Math.random() - 0.2 },
					} );
				}, 250 );
			},
		},

		lottie: {
			animations: new Map(), // store animations per container

			init: function() {
				PROJECT.lottie.withObserver();
			},

			setUp: function( container, path ) {
				const animation = lottie.loadAnimation( {
					container: container,
					renderer: 'svg',
					loop: false,
					autoplay: false, // load but don't play yet
					path: path,
					speed: 100,
				} );

				// Save animation instance for later control
				PROJECT.lottie.animations.set( container, animation );

				return animation;
			},

			withObserver: function() {
				const wrappers = document.querySelectorAll( '.jsLottie' );

				wrappers.forEach( ( el ) => {
					const lottieContainer = el.querySelector( '.jsLottieContainer' );

					if ( !lottieContainer ) return;

					const path = lottieContainer.getAttribute( 'data-json' );

					if ( !path ) {
						console.warn( 'No data-json attribute found on', lottieContainer );
						return;
					}

					if ( !PROJECT.lottie.animations.has( lottieContainer ) ) {
						PROJECT.lottie.setUp( lottieContainer, path );
					}

					const observer = new IntersectionObserver(
						( entries, observer ) => {
							entries.forEach( ( entry ) => {
								if ( entry.isIntersecting ) {
									const animation = PROJECT.lottie.animations.get( lottieContainer );

									if ( animation.isPaused ) {
										animation.setSpeed( 1 );
										animation.play();
									}

									observer.unobserve( entry.target );
								}
							} );
						},
						{ threshold: 0.75 },
					);

					observer.observe( lottieContainer );
				} );
			},
		},

		cards: {
			init: function() {
				PROJECT.cards.calcHeight();

				window.onresize = function() {
					PROJECT.cards.calcHeight();
				};
			},

			calcHeight() {
				let cards = document.querySelectorAll( '.jsCardHeight' );

				if ( typeof cards === 'object' && cards.length > 0 ) {
					cards.forEach( ( card, index ) => {
						const height = card.scrollHeight;

						card.style.setProperty( '--cardHight', height + 'px' );
					} );
				}
			},
		},

		stepsCarousel: {
			init: function() {
				PROJECT.stepsCarousel.initStepsCarousel();
			},

			initStepsCarousel: function() {
				const carousels = document.querySelectorAll( '.jsStepsCarousel' );

				if ( !carousels.length ) return;

				carousels.forEach( ( carousel ) => {
					const stepItems    = carousel.querySelectorAll( '.jsStepItem' );
					const stepContents = carousel.querySelectorAll( '.jsStepContent' );
					const stepImages   = carousel.querySelectorAll( '.jsStepImage' );

					stepItems.forEach( ( item ) => {
						item.addEventListener( 'click', function() {
							const stepIndex = this.getAttribute( 'data-step' );

							stepItems.forEach( ( el ) => el.classList.remove( 'is-active' ) );
							stepContents.forEach( ( el ) => el.classList.remove( 'is-active' ) );
							stepImages.forEach( ( el ) => el.classList.remove( 'is-active' ) );

							this.classList.add( 'is-active' );

							const relatedContent = this.querySelector( '.jsStepContent' );
							if ( relatedContent ) {
								relatedContent.classList.add( 'is-active' );
							}

							const relatedImage = carousel.querySelector( `.jsStepImage[data-step="${stepIndex}"]` );
							if ( relatedImage ) {
								relatedImage.classList.add( 'is-active' );
							}
						} );
					} );
				} );
			},
		},

		lightboxGallery: {
			init: function() {
				$( document ).on( 'click', '.jsLightboxGalleryTrigger', PROJECT.lightboxGallery.openTrigger );

				$( document ).on( 'click', '.jsLightboxGalleryClose', PROJECT.lightboxGallery.close );

				$( document ).on( 'keydown', function( e ) {
					if ( e.key === 'Escape' && $( '.jsLightboxGalleryElement' ).length ) {
						PROJECT.lightboxGallery.close( e );
					}
				} );
			},

			openTrigger: function( e ) {
				e.preventDefault();

				const ids = $( this ).data( 'image-ids' );

				PROJECT.lightboxGallery.open( ids );
			},

			open: function( ids ) {
				if ( !ids || ids.length === 0 ) return;

				$( 'html' ).addClass( 'state-c-loader--loader-visible' );

				$.ajax( {
					url: tabs_globals.ajaxurl,
					type: 'GET',
					data: {
						action: 'lightbox_gallery_load',
						image_ids: ids,
					},
					success: function( html ) {
						const $lightbox = $( $.parseHTML( html ) );
						$lightbox.hide();

						$( 'body' ).append( $lightbox );

						$( 'html' ).addClass( 'state-v-lightbox-gallery--lightbox-open' );

						$lightbox
						.css( 'display', 'flex' )
						.hide()
						.fadeIn( 300 );

						PROJECT.lightboxGallery.initSlider();
					},
					complete: function() {
						$( 'html' ).removeClass( 'state-c-loader--loader-visible' );
					},
				} );
			},

			initSlider: function() {
				let lightboxElement = document.querySelectorAll( '.jsLightboxGalleryElement' );

				if ( lightboxElement.length > 0 ) {
					lightboxElement.forEach( function( element ) {
						const mainSliderElem      = element.querySelector( '.jsLightboxGallerySlider' );
						const thumbnailSliderElem = element.querySelector( '.jsLightboxGalleryThumbnailSlider' );

						const mainSplide = new Splide( mainSliderElem, {
							// type: 'fade',
							rewind: true,
							pagination: false,
							arrows: false,
						} );

						const thumbnailSplide = new Splide( thumbnailSliderElem, {
							fixedWidth: 80,
							fixedHeight: 80,
							gap: 16,
							rewind: true,
							pagination: false,
							isNavigation: true,
						} );

						mainSplide.sync( thumbnailSplide );
						mainSplide.mount();
						thumbnailSplide.mount();
					} );
				}
			},

			close: function( e ) {
				e.preventDefault();

				$( '.jsLightboxGalleryElement' ).fadeOut( 300, function() {
					$( this ).remove();

					$( 'html' ).removeClass( 'state-v-lightbox-gallery--lightbox-open' );
				} );
			},
		},

		intakePopup: {

			init: function() {
				$(document).on('click', '.jsIntakePopupClose', PROJECT.intakePopup.close);
				$(document).on('click', '.jsIntakePopupOverlay', PROJECT.intakePopup.close);
				$(document).on('click', '.jsIntakePopupOpen', PROJECT.intakePopup.open);

				$( document ).on( 'keydown', function( e ) {
					if ( e.key === 'Escape' && $( 'body' ).hasClass( 'state-v-intake-popup--popup-open' ) ) {
						PROJECT.intakePopup.close( e );
					}
				} );
			},

			close: function( e ) {
				if ( e ) e.preventDefault();

				$( 'body' ).removeClass( 'state-v-intake-popup--popup-open' );
			},

			open: function(e) {

				e.preventDefault();

				$('body').addClass('state-v-intake-popup--popup-open');

			}

		},

		navigationBar: {
			clickElem: '.jsNotificationBarClose',
			mainElem: '.jsNotificationBar',

			init: function() {
				$( document ).on( 'click', PROJECT.navigationBar.clickElem, PROJECT.navigationBar.setCookieOnClick );
			},

			setCookieOnClick() {
				window.setCookie( 'hide_notification_bar', '1' );

				$( PROJECT.navigationBar.mainElem ).hide();
			},
		},

		navDrag: {
			init: function() {
				if ( PROJECT.prefs.isReduced ) return;

				const sliders = document.querySelectorAll( '.jsNavScroll' );

				sliders.forEach( ( slider ) => PROJECT.navDrag.setupSlider( slider ) );
			},

			setupSlider: function( slider ) {
				const state = {
					isDown: false,
					startX: 0,
					scrollLeft: 0,
					isDragging: false,
					dragThreshold: 8, // pixels before we start counting as drag
					moved: 0,
				};

				slider.addEventListener( 'mousedown', ( e ) => {
					state.isDown     = true;
					state.startX     = e.pageX;
					state.scrollLeft = slider.scrollLeft;
					state.isDragging = false;
					state.moved      = 0;
					slider.classList.add( 'is-dragging' );
				} );

				document.addEventListener( 'mousemove', ( e ) => {
					if ( !state.isDown ) return;

					const dx    = e.pageX - state.startX;
					state.moved = dx;

					if ( Math.abs( dx ) > state.dragThreshold ) state.isDragging = true;

					if ( state.isDragging ) {
						slider.scrollLeft = state.scrollLeft - dx;
					}
				} );

				document.addEventListener( 'mouseup', () => {
					state.isDown = false;
					slider.classList.remove( 'is-dragging' );
					state.isDragging = false;
				} );

				slider.addEventListener(
					'touchstart',
					( e ) => {
						state.startX     = e.touches[ 0 ].pageX;
						state.scrollLeft = slider.scrollLeft;
						state.isDragging = false;
						state.moved      = 0;
					},
					{ passive: true },
				);

				slider.addEventListener(
					'touchmove',
					( e ) => {
						const dx    = e.touches[ 0 ].pageX - state.startX;
						state.moved = dx;

						if ( Math.abs( dx ) > state.dragThreshold ) state.isDragging = true;

						if ( state.isDragging ) {
							e.preventDefault(); // Prevent the page from scrolling
							slider.scrollLeft = state.scrollLeft - dx;
						}
					},
					{ passive: false },
				);

				slider.addEventListener( 'touchend', () => {
					state.isDragging = false;
				} );

				slider.querySelectorAll( 'a' ).forEach( ( link ) => {
					link.addEventListener( 'click', ( e ) => {
						if ( state.isDragging ) {
							e.preventDefault();
							e.stopPropagation();
						}
					} );
				} );
			},
		},

		marquee: {
			scrollEndDelay: 200,
			scrollEndTimer: null,
			init: function() {
				var self        = this;
				var marqueeSvgs = document.querySelectorAll( '.s-marquee__curve svg' );
				if ( !marqueeSvgs.length ) return;

				function pauseAll() {
					marqueeSvgs.forEach( function( svg ) {
						if ( svg.pauseAnimations ) svg.pauseAnimations();
					} );
				}

				function unpauseAll() {
					marqueeSvgs.forEach( function( svg ) {
						if ( svg.unpauseAnimations ) svg.unpauseAnimations();
					} );
				}

				function onScrollEnd() {
					self.scrollEndTimer = null;
					unpauseAll();
				}

				function scheduleUnpause() {
					if ( self.scrollEndTimer ) clearTimeout( self.scrollEndTimer );
					self.scrollEndTimer = setTimeout( onScrollEnd, self.scrollEndDelay );
				}

				window.addEventListener( 'scroll', function() {
					pauseAll();
					scheduleUnpause();
				}, { passive: true } );

				window.addEventListener( 'touchmove', function() {
					pauseAll();
					scheduleUnpause();
				}, { passive: true } );
			},
		},
	};

	var UTIL = {
		exec: function( controller, action ) {
			var ns = PROJECT;
			action = action === undefined ? 'init' : action;

			if ( controller !== '' && ns[ controller ] && typeof ns[ controller ][ action ] === 'function' ) {
				ns[ controller ][ action ]();
			}
		},

		init: function() {
			var body       = document.body,
				controller = body.getAttribute( 'data-controller' ),
				action     = body.getAttribute( 'data-action' );

			UTIL.exec( 'common' );
			UTIL.exec( controller );
			UTIL.exec( controller, action );
		},
	};

	//$.PROJECT = PROJECT; // Make global available

	$( window ).ready( UTIL.init );
} );
